import { createContext } from 'react'

interface ITooltipContextProps {
  enabled: boolean
}

export const TooltipContext = createContext<ITooltipContextProps>({ enabled: true })
